<script setup>
import baseButton from "@/components/app/buttons/Base.vue";
import chevronUp from "@/components/app/icons/chevron-up.vue";
import chevronDown from "@/components/app/icons/chevron-down.vue";
import { useToggleAll } from "@/composables/useToggleAll";
import { useToggle } from "@/composables/useToggle";
import { defineProps } from "vue";

const props = defineProps({
  text: {
    type: String,
    default: "",
  },
  id: {
    type: [String, Number],
    required: true,
  },
});

const { isOpen: isGloballyOpen, toggle: toggleGlobal } = useToggleAll();
const {
  // eslint-disable-next-line no-unused-vars
  state: isIndividuallyOpen,
  // eslint-disable-next-line no-unused-vars
  toggle: toggleIndividual,
  close,
  open,
} = useToggle();

const toggle = () => {
  toggleGlobal(props.id);
  if (isGloballyOpen(props.id)) {
    open();
  } else {
    close();
  }
};
</script>

<template>
  <baseButton
    @click="toggle"
    class="font-extralight menu-item-name"
    :label="props.text"
  >
    <template #iconLeft>
      <slot name="iconLeft"></slot>
    </template>
    <template #iconRight>
      <chevronUp v-if="!isGloballyOpen(props.id)" fill="white" width="12px" />
      <chevronDown v-if="isGloballyOpen(props.id)" fill="white" width="12px" />
    </template>
  </baseButton>
  <div
    v-if="isGloballyOpen(props.id)"
    @click="close"
    @mouseenter="open"
    class="mt-2 w-full"
  >
    <slot name="dropdownItems"></slot>
  </div>
</template>
